<template>
  <Modal
    ref="feedbackModal"
    :title="'Contact Us'"
  >
    <template #modal-main>
      <ContactFormLanding class="text-align-left " />
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import ContactFormLanding from '@/components/ContactFormLanding.vue';

export default {
  name: 'FeedbackModal',
  components: {
    Modal,
    ContactFormLanding,
  },
  methods: {
    showModal() {
      this.$refs.feedbackModal.showModal();
    },
  },
};
</script>

<style lang="scss" scoped>
.text-align-left {
  text-align: left !important;
}

</style>
